// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Ruler,
    RulerDimensionLine,
    RussianRuble,
    Sailboat,
    Salad,
    Sandwich,
    Satellite,
    SatelliteDish,
    SaudiRiyal,
    Save,
    SaveAll,
    SaveCheck,
    SaveOff,
    SavePen,
    SavePlus,
    Scale,
    Scale3d,
    Scaling,
    Scan,
    ScanBarcode,
    ScanBox,
    ScanEye,
    ScanFace,
    ScanHeart,
    ScanLine,
    ScanQrCode,
    ScanSearch,
    ScanSquare,
    ScanText,
    School,
    Scissors,
    ScissorsLineDashed,
    Scooter,
    ScreenShare,
    ScreenShareOff,
    Scroll,
    ScrollText,
    Search,
    SearchAlert,
    SearchCheck,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "ruler" through "search-check", inclusive. */
const shard: Record<string, LucideIcon> = {
    ruler: Ruler,
    "ruler-dimension-line": RulerDimensionLine,
    "russian-ruble": RussianRuble,
    sailboat: Sailboat,
    salad: Salad,
    sandwich: Sandwich,
    satellite: Satellite,
    "satellite-dish": SatelliteDish,
    "saudi-riyal": SaudiRiyal,
    save: Save,
    "save-all": SaveAll,
    "save-check": SaveCheck,
    "save-off": SaveOff,
    "save-pen": SavePen,
    "save-plus": SavePlus,
    scale: Scale,
    "scale-3d": Scale3d,
    scaling: Scaling,
    scan: Scan,
    "scan-barcode": ScanBarcode,
    "scan-box": ScanBox,
    "scan-eye": ScanEye,
    "scan-face": ScanFace,
    "scan-heart": ScanHeart,
    "scan-line": ScanLine,
    "scan-qr-code": ScanQrCode,
    "scan-search": ScanSearch,
    "scan-square": ScanSquare,
    "scan-text": ScanText,
    school: School,
    scissors: Scissors,
    "scissors-line-dashed": ScissorsLineDashed,
    scooter: Scooter,
    "screen-share": ScreenShare,
    "screen-share-off": ScreenShareOff,
    scroll: Scroll,
    "scroll-text": ScrollText,
    search: Search,
    "search-alert": SearchAlert,
    "search-check": SearchCheck,
};

export default shard;
